import { render, staticRenderFns } from "./PolicyFormCarrier.vue?vue&type=template&id=b82b29bc&scoped=true&"
import script from "./PolicyFormCarrier.vue?vue&type=script&lang=ts&"
export * from "./PolicyFormCarrier.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyFormCarrier.vue?vue&type=style&index=0&id=b82b29bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82b29bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
